import type { ReactNode } from "react";
import { CollapsibleSection } from "../CollapsibleSection/CollapsibleSection";

interface Props {
  /** Section header label (leader name, `__other__` copy, etc.). */
  label: string;
  /** Row count displayed alongside the header. */
  count: number;
  /** Optional pin-level badge for the leader. Zero hides the badge. */
  pinLevel?: number;
  /** Rows or nested `<GroupLeaderSection>` children. */
  children?: ReactNode;
  "data-testid"?: string;
  /** When true, disables the expand/collapse toggle on mobile entirely. */
  disableCollapse?: boolean;
  /** Changing this value forces the section to expand. */
  expandKey?: unknown;
}

export const GroupLeaderSection = ({
  label,
  count,
  pinLevel,
  children,
  "data-testid": dataTestId,
  disableCollapse,
  expandKey,
}: Props) => {
  return (
    <CollapsibleSection
      label={label}
      count={count}
      pinLevel={pinLevel}
      data-testid={dataTestId}
      disableCollapse={disableCollapse}
      expandKey={expandKey}
    >
      {children}
    </CollapsibleSection>
  );
};
